import React from 'react';

import IconButton, { IconButtonTypeMap } from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';

export interface IBaseIconButtonProps {
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  size?: IconButtonTypeMap['props']['size'];
  tooltip?: string;
  loading?: boolean;
  href?: string;
  target?: string;
  htmlColor?: string;
  disabled?: boolean;
}

export default function BaseIconButton(
  props: IBaseIconButtonProps & {
    children?: React.ReactElement;
  }
) {
  const {
    onClick,
    size,
    tooltip,
    children,
    loading,
    href,
    target,
    disabled,
  } = props;

  if (loading) {
    return <CircularProgress size={15} color="inherit" />;
  }

  const button = (
    <IconButton
      disabled={disabled}
      onClick={onClick}
      size={size || 'small'}
      href={href as string}
      target={target}
    >
      {children}
    </IconButton>
  );

  if (tooltip) {
    return <Tooltip title={tooltip}>{button}</Tooltip>;
  }

  return button;
}
